export const intersection = (a, b) =>
  (a || []).filter((n) => (b || []).indexOf(n) > -1);
export const difference = (a, b) =>
  (a || []).filter((n) => (b || []).indexOf(n) === -1);

export const aggregateToObject = (key, data) => {
  const result = {};
  data.forEach((res) => {
    if (!result[res[key]]) {
      result[res[key]] = [];
    }
    result[res[key]].push(res);
  });

  return result;
};

export const areArraysEqual = (array1, array2) => {
  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    return false;
  }

  if (array1.length !== array2.length) {
    return false;
  }

  for (let i = 0; i < array1.length; i++) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }

  return true;
};

export const sortArrayByName = (list) => {
  return list.sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
  );
};
